import { HttpHeaders } from "@angular/common/http";
import { environment } from "../../environments/environment";
export class ConstantsService {
	public httpOptions = new HttpHeaders({ 'Content-Type': 'application/json' });

	public httpCustomOptions = {
		headers: new HttpHeaders({
			'Content-Type': 'application/json, application/x-www-form-urlencoded;charset=ISO-8859-15',
			'Accept': 'application/json',
		})
	};

	public baseAPIURL = '';
	constructor() {
		this.baseAPIURL = environment.baseAPIURL;
	}
}